/**
 * HTML特殊文字をエスケープする
 */
module.exports = function(str){
	str = this.toStr(str);
	str = str.replace(/\&/g, '&amp;');
	str = str.replace(/\</g, '&lt;');
	str = str.replace(/\>/g, '&gt;');
	str = str.replace(/\"/g, '&quot;');
	return str;
}
